import { EnumValidationDisplay } from "../enum/enum_validation_display";

export class ResponseModel {

  constructor() {
    this.ErrorList = new Array<string>();
    this.ErrorTitle = null;
    this.ShowException = false;
    this.ShowError = false;
  }

  Model: any;
  IsError: boolean;
  ShowError: boolean;
  ErrorList: Array<string>;
  ErrorTitle: string;
  ShowSuccess: boolean;
  SuccessMessage: string;
  IsException: boolean;
  ShowException: boolean;
  ErrorDisplay: EnumValidationDisplay;
}
